import { useAuth } from 'restaurantAdmin/context/AuthContext';
import { SETTINGS_REPORTS_PATH } from 'restaurantAdmin/paths';
import { useServiceSearchParams } from 'restaurantAdmin/reservations/service/hooks/useServiceSearchParams';
import { NavigationMenu } from '@base-ui/react/navigation-menu';
import { Avatar } from '@components/avatar/Avatar';
import { useIsOpen } from '@shared/hooks/useIsOpen';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import typography from '~styles/typography.scss';
import { SignOutModal } from '../auth/SignOutModal';
import styles from './AvatarDropdown.scss';

export const AvatarDropdown = () => {
  const { adminName } = useAuth();
  const {
    isOpen: isSignOutModalOpen,
    close: closeSignOutModal,
    open: openSignOutModal,
  } = useIsOpen();
  const { openServiceOverviewDrawer } = useServiceSearchParams();

  const names = adminName?.split(' ') || [];
  const firstName = names[0];
  const lastName = names.length > 1 ? names[names.length - 1] : '';

  return (
    <NavigationMenu.Root>
      <NavigationMenu.List>
        <NavigationMenu.Item>
          <NavigationMenu.Trigger
            className={cx(typography.t2, {
              [styles.menuButton]: true,
            })}
          >
            <Avatar firstName={firstName} lastName={lastName} />
          </NavigationMenu.Trigger>
          <NavigationMenu.Content className={styles.menuContent}>
            <span className={styles.menuGroup}>
              <ul>
                <li>
                  <Link
                    className={cx(typography.t1, styles.link)}
                    to={SETTINGS_REPORTS_PATH}
                  >
                    Reports
                  </Link>
                </li>
                <li>
                  <button
                    className={cx(
                      typography.t1,
                      styles.link,
                      styles.menuButton,
                    )}
                    onClick={openServiceOverviewDrawer}
                    type="button"
                  >
                    Service Overview
                  </button>
                </li>
              </ul>
              <hr />
            </span>
            <span className={styles.menuGroup}>
              <ul>
                <li>
                  <button
                    className={cx(
                      typography.t1,
                      styles.link,
                      styles.menuButton,
                      styles.signOutButton,
                    )}
                    onClick={openSignOutModal}
                    type="button"
                  >
                    Sign Out
                  </button>
                </li>
              </ul>
            </span>
          </NavigationMenu.Content>
        </NavigationMenu.Item>
      </NavigationMenu.List>
      <NavigationMenu.Portal>
        <NavigationMenu.Positioner
          className={styles.positioner}
          sideOffset={0}
          collisionPadding={{ top: 5, bottom: 5, left: 20, right: 20 }}
          collisionAvoidance={{ side: 'none' }}
        >
          <NavigationMenu.Popup>
            <NavigationMenu.Viewport />
          </NavigationMenu.Popup>
        </NavigationMenu.Positioner>
      </NavigationMenu.Portal>

      <SignOutModal
        closeModal={closeSignOutModal}
        isOpen={isSignOutModalOpen}
      />
    </NavigationMenu.Root>
  );
};
